import { noop } from 'lodash'
import React from 'react'
import NumberFormat, { NumberFormatValues } from 'react-number-format'
import { Testable } from 'utils-next/types'

import { InputBaseComponentProps } from '@mui/material'
import { InputProps } from '@mui/material/Input'

export type NumberInputProps = Testable &
  Pick<InputBaseComponentProps, 'onChange'> &
  Pick<InputProps, 'inputRef' | 'name' | 'id'>

export function NumberInput({ inputRef, onChange = noop, ...otherProps }: NumberInputProps) {
  const onValueChange = (data: NumberFormatValues) => {
    onChange({
      target: {
        name: otherProps.name,
        id: otherProps.id,
        value: data.value,
      },
    } as any)
  }
  return <NumberFormat getInputRef={inputRef} onValueChange={onValueChange} thousandSeparator {...otherProps} />
}
